import React, { FC, useCallback, useMemo, useRef } from 'react';
import { FilterSelect } from '../../../components/FilterSelect/FilterSelect';
import styles from './SearchComponents.module.less';
import { SortTypeSelector } from './filters/SortTypeSelector';
import { MasterDataFilter } from './filters/MasterDataFilter';
import { PostedDateSelector } from './filters/PostedDateSelector';
import { SalarySelector, SalarySelectorValue } from './filters/SalarySelector';
import { Button, Divider } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { useSearchContext } from '../SearchContext';
import { useCachedData } from '../../../connection/CacheContext';
import { CompanyFilter } from './filters/CompanyFilter';
import { AdStatusFilter } from './filters/AdStatusFilter';
import { LocationFilter, LocationsValue } from './filters/LocationFilter';
import { TypeFilter } from './filters/TypeFilter';
import { CandidateNavBar } from '../../../layout/candidate/CandidateNavBar';

export const SearchFilterBar: FC<{ hideFilters?: boolean; onReset?: () => void }> = (props) => {
  const { query, search, reset } = useSearchContext();
  const ref = useRef<HTMLDivElement>(null);
  const { masterdata, mainType } = useCachedData();
  CandidateNavBar;

  const scroll = (scrollOffset: number) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ref.current?.scrollTo({
      left: (ref.current?.scrollLeft ?? 0) + scrollOffset,
      behavior: 'smooth',
    });
  };
  const jobTypes = useMemo(
    () =>
      query?.jobType || query?.jobCategory
        ? [...(query?.jobType ?? []), ...(query?.jobCategory ?? [])]
        : undefined,
    [query?.jobCategory, query?.jobType],
  );

  const getJobTypeValues = useCallback(
    (types?: string[]) => {
      if (types === undefined) {
        return { jobType: undefined, jobCategory: undefined };
      }
      const mainTypeId = mainType['Job Types'];
      const mainCategoryId = mainType['Job Category'];
      const allJobTypes = masterdata[mainTypeId];
      const allJobCategory = masterdata[mainCategoryId];
      const jobType = allJobTypes.filter((a) => types.indexOf(`Job Types-${a.id}`) !== -1);
      const jobCategory = allJobCategory.filter(
        (a) => types.indexOf(`Job Category-${a.id}`) !== -1,
      );
      return {
        jobType: jobType.length > 0 ? jobType.map((v) => `Job Types-${v.id}`) : undefined,
        jobCategory:
          jobCategory.length > 0 ? jobCategory.map((v) => `Job Category-${v.id}`) : undefined,
      };
    },
    [mainType, masterdata],
  );

  const handleJobTypeChange = useCallback(
    (types?: string[]) => {
      search(getJobTypeValues(types));
    },
    [getJobTypeValues, search],
  );

  // useEffect(() => {
  //   if (props.showOnlyReleventFilters === true) {
  //     setShowAllFilters(false);
  //     setShowRadioButtons(true);
  //   }
  // }, []);

  // const showAllFilters = true;
  console.log('LOC', query);
  return (
    <div className={styles.searchFilterContainer}>
      <CaretLeftOutlined className={styles.arrowicon} onClick={() => scroll(-50)} />
      <div className={styles.searchFilterBar} ref={ref}>
        {props.hideFilters && (
          <AdStatusFilter
            value={query.status == null ? 'All' : query.status}
            onChange={(status?: string) => {
              // if (status === 'All') {
              //   search({ status: undefined });
              // } else {
              search({ status });
              // }
            }}
          />
        )}
        {!props.hideFilters && (
          <FilterSelect
            id={'dropdown-most-relevent-filter'}
            // value={query.recent === undefined ? undefined : query.recent ? 'recent' : 'relevant'}
            value={query?.recent ? 'recent' : 'relevant'}
            onChange={(sort?: string) => search({ recent: sort === 'recent' })}
            title={query?.recent ? 'Most Recent' : 'Most Relevant'}>
            <SortTypeSelector />
          </FilterSelect>
        )}
        <FilterSelect
          id={'dropdown-posted-date-filter'}
          value={query?.posted}
          onChange={(posted?: string) => search({ posted })}
          title={'Posted Date'}>
          <PostedDateSelector />
        </FilterSelect>
        <FilterSelect
          calculateCount={(value: any) => {
            if (value) {
              const c = (value.location ?? []).length + (value.country ?? []).length;
              if (c > 0) {
                return c;
              }
            }
            return undefined;
          }}
          id={'dropdown-job-location-filter'}
          value={
            query.location || query.country
              ? { location: query.location, country: query.country }
              : undefined
          }
          allText={'Sri Lanka'}
          onChange={(location?: LocationsValue) =>
            search({ location: location?.location, country: location?.country })
          }
          title={'Location'}
          search>
          <LocationFilter
            title={'Location'}
            getQuery={(value: any) => ({ location: value?.location, country: value?.country })}
          />
        </FilterSelect>
        <FilterSelect
          value={jobTypes}
          onChange={handleJobTypeChange}
          title={'Job Types'}
          id={'dropdown-job-type-filter'}>
          <TypeFilter id={'job-type-filter'} getQuery={getJobTypeValues} title={'Job Type'} />
        </FilterSelect>
        {!props.hideFilters && (
          <FilterSelect
            value={query.sector}
            onChange={(sector?: string[]) => search({ sector })}
            title={'Sector'}
            id={'dropdown-sector-filter'}
            search>
            <MasterDataFilter
              id={'job-sector-filter'}
              aggrName={'sector'}
              getQuery={(sector?: string[]) => ({ sector })}
              enumName={'Sector'}
              title={'Sector'}
            />
          </FilterSelect>
        )}
        {/*<FilterSelect*/}
        {/*  title={'Job Function'}*/}
        {/*  search*/}
        {/*  id={'dropdown-job-function-filter'}*/}
        {/*  value={query.jobFunction}*/}
        {/*  onChange={(jobFunction?: string[]) => search({ jobFunction })}>*/}
        {/*  <MasterDataFilter*/}
        {/*    id={'job-function-filter'}*/}
        {/*    aggrName={'jobFunction'}*/}
        {/*    getQuery={(jobFunction?: string[]) => ({ jobFunction })}*/}
        {/*    enumName={'Job Function'}*/}
        {/*    title={'Job Function'}*/}
        {/*  />*/}
        {/*</FilterSelect>*/}
        {!props.hideFilters && (
          <FilterSelect
            title={'Company'}
            search
            id={'dropdown-company-filter'}
            value={query.company}
            onChange={(company?: string[]) => search({ company })}>
            <CompanyFilter getQuery={(company?: string[]) => ({ company })} />
          </FilterSelect>
        )}
        {!props.hideFilters && (
          <FilterSelect
            title={'Salary'}
            search
            id={'dropdown-salary-filter'}
            value={
              !query.salary_type && !query.currency
                ? undefined
                : {
                    type: query.salary_type,
                    from: query.SalaryDown,
                    to: query.SalaryUp,
                    currency: query.currency,
                    onlyCurrency: query.onlyCurrency,
                  }
            }
            onChange={(salary?: SalarySelectorValue) =>
              search({
                salary_type: salary?.type,
                SalaryDown: salary?.from,
                SalaryUp: salary?.to,
                currency: salary?.currency,
                onlyCurrency: salary?.onlyCurrency,
              })
            }>
            <SalarySelector />
          </FilterSelect>
        )}
        <FilterSelect
          title={'On-site/Remote'}
          value={query.workplaceType}
          id={'dropdown-work-place-type-filter'}
          onChange={(workplaceType?: string[]) => search({ workplaceType })}>
          <MasterDataFilter
            id={'work-place-type-filter'}
            aggrName={'workplaceType'}
            getQuery={(workplaceType?: string[]) => ({ workplaceType })}
            enumName={'Workplace Type'}
            title={'On-site/Remote'}
          />
        </FilterSelect>
        <FilterSelect
          title={'Experience Level'}
          value={query.experienceLevel}
          id={'dropdown-experience-level-filter'}
          onChange={(experienceLevel?: string[]) => search({ experienceLevel })}>
          <MasterDataFilter
            id={'experience-level-filter'}
            aggrName={'experienceLevel'}
            getQuery={(experienceLevel?: string[]) => ({ experienceLevel })}
            enumName={'Experience Level'}
            title={'Experience Level'}
          />
        </FilterSelect>
        {/*<SuitableForGraduate*/}
        {/*  value={query.graduate}*/}
        {/*  onChange={(graduate?: boolean) => search({ graduate })}*/}
        {/*/>*/}
        <Divider type={'vertical'} style={{ height: 'unset' }} />
        <Button
          type={'link'}
          size={'small'}
          className="text-primary !hover:text-primary"
          onClick={() => {
            reset();
            if (props.onReset) {
              props.onReset();
            }
          }}
          id={'nav-btn-reset-filter'}>
          Reset
        </Button>
      </div>
      <CaretRightOutlined className={styles.arrowicon} onClick={() => scroll(50)} />
    </div>
  );
};
